import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    mainAccount: 'Main account',
  },
  fr: {
    mainAccount: 'Compte principal',
  },
} as const);

export default locales;
